import React from 'react';
import { Loadable } from 'shared/hocs/loadable';
import { Loader } from 'shared/ui/loader';


export const SurveyConstructorIqosLoadable = Loadable({
    loader: (): any => import('./SurveyConstructorIqos').then((res) => res.SurveyConstructorIqos),
    loading: <Loader/>,
});
